import {
  IonTabs,
  IonTabBar,
  IonTabButton,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
} from "@ionic/react";
import { Navigate, Route, Routes } from 'react-router-dom';
import { list, radioOutline, search, person, trophy, peopleOutline } from "ionicons/icons";
import { MyLeaguesTab } from "./main-tabs/my-leagues/MyLeaguesTab";
import { ChannelsTab } from "./main-tabs/channels/ChannelsTab";
import { SearchTab } from "./main-tabs/search/SearchTab";
import { NetworkTab } from "./main-tabs/network/NetworkTab";
import { CareerOrganizationPage } from "./main-tabs/network/CareerOrganizationPage";
import { ProfileTab } from "./main-tabs/profile/ProfileTab";
import { SettingsPage } from "./main-tabs/profile/SettingsPage";
import { PublicProfilePage } from "./main-tabs/profile/PublicProfilePage";
import { CareerOverlapsPage } from "./main-tabs/profile/CareerOverlapsPage";
import { ChannelFollowers } from "./main-tabs/channels/components/ChannelFollowers";
import { EditChannel } from "./main-tabs/channels/components/EditChannel";
import { PostDetailPage } from "./main-tabs/channels/components/PostDetailPage";
import { CreateEditPost } from "./main-tabs/channels/components/CreateEditPost";
import { ViewChannel } from "./main-tabs/channels/ViewChannel";
import { ChannelSearchPage } from "./main-tabs/channels/ChannelSearchPage";
import { LeagueSearchPage } from "./main-tabs/search/LeagueSearchPage";
import CompetitionTab from "./main-tabs/competition/CompetitionTab";
import MatchViewPage from "./main-tabs/competition/MatchViewPage";
import SeasonRosterPage from "./main-tabs/competition/SeasonRosterPage";
import RosterPage from "./main-tabs/my-leagues/RosterPage";
import { useFeatureFlags } from "../hooks/useFeatureFlags";
import { FeatureFlag } from "../types/featureFlags";

export const TabsPage = () => {
  const { isEnabled } = useFeatureFlags();
  const showChannels = isEnabled(FeatureFlag.POSTS);
  // The "Red" tab replaces "Buscar" for users with the social features.
  const showNetwork = isEnabled(FeatureFlag.SOCIAL);

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Routes>
        <Route
          path="/app/main/mis-ligas/buscar"
          element={<LeagueSearchPage />}
        />
        <Route path="/app/main/mis-ligas" element={<MyLeaguesTab />} />
        <Route path="/app/main/competition" element={<CompetitionTab />} />
        <Route
          path="/app/main/competition/partidos/:matchId"
          element={<MatchViewPage />}
        />
        <Route
          path="/app/main/competition/plantilla/:seasonCompetitionTeamId"
          element={<SeasonRosterPage />}
        />
        <Route
          path="/app/main/competition/equipos/:teamId"
          element={<RosterPage />}
        />
        <Route path="/app/main/channels" element={<ChannelsTab />} />
        <Route
          path="/app/main/channels/post/:postId"
          element={<PostDetailPage />}
        />
        <Route
          path="/app/main/channels/:channelId/publicar"
          element={<CreateEditPost />}
        />
        <Route
          path="/app/main/channels/:channelId/publicar/:postId"
          element={<CreateEditPost />}
        />
        <Route path="/app/main/channels/:channelId" element={<ViewChannel />} />
        <Route
          path="/app/main/channels/:channelId/editar"
          element={<EditChannel />}
        />
        <Route
          path="/app/main/channels/buscar"
          element={<ChannelSearchPage />}
        />
        <Route path="/app/main/buscar" element={<SearchTab />} />
        <Route path="/app/main/red" element={<NetworkTab />} />
        <Route
          path="/app/main/red/entidades/:careerOrganizationId"
          element={<CareerOrganizationPage />}
        />
        <Route
          path="/app/main/red/perfiles/:userId"
          element={
            <PublicProfilePage
              defaultBackHref="/app/main/red"
              channelPathPrefix="/app/main/red/canal"
              overlapsPathPrefix="/app/main/red/experiencia"
            />
          }
        />
        <Route
          path="/app/main/red/experiencia/:careerEntryId"
          element={
            <CareerOverlapsPage
              defaultBackHref="/app/main/red"
              profilePathPrefix="/app/main/red/perfiles"
            />
          }
        />
        <Route
          path="/app/main/red/canal/:channelId"
          element={<ViewChannel defaultBackHref="/app/main/red" />}
        />
        <Route path="/app/main/perfil" element={<ProfileTab />} />
        <Route
          path="/app/main/perfil/configuracion"
          element={<SettingsPage />}
        />
        <Route
          path="/app/main/perfil/usuario/:userId"
          element={<PublicProfilePage />}
        />
        <Route
          path="/app/main/perfil/experiencia/:careerEntryId"
          element={<CareerOverlapsPage />}
        />
        <Route
          path="/app/main/perfil/canal/:channelId"
          element={<ViewChannel />}
        />
        <Route
          path="/app/main/perfil/canal/:channelId/seguidores"
          element={<ChannelFollowers />}
        />
        <Route
          path="/app/main/perfil/canal/:channelId/editar"
          element={<EditChannel />}
        />
        <Route path="/app/main" element={<Navigate to="/app/main/mis-ligas" replace />} />
        </Routes>
      </IonRouterOutlet>

      <IonTabBar slot="bottom">
        <IonTabButton tab="mis-ligas" href="/app/main/mis-ligas">
          <IonIcon icon={list} />
          <IonLabel>Mis Ligas</IonLabel>
        </IonTabButton>

        <IonTabButton tab="competition" href="/app/main/competition">
          <IonIcon icon={trophy} />
          <IonLabel>Competición</IonLabel>
        </IonTabButton>

        {showChannels && (
          <IonTabButton tab="channels" href="/app/main/channels">
            <IonIcon icon={radioOutline} />
            <IonLabel>Canales</IonLabel>
          </IonTabButton>
        )}

        {showNetwork ? (
          <IonTabButton tab="red" href="/app/main/red">
            <IonIcon icon={peopleOutline} />
            <IonLabel>Red</IonLabel>
          </IonTabButton>
        ) : (
          <IonTabButton tab="buscar" href="/app/main/buscar">
            <IonIcon icon={search} />
            <IonLabel>Buscar</IonLabel>
          </IonTabButton>
        )}

        <IonTabButton tab="perfil" href="/app/main/perfil">
          <IonIcon icon={person} />
          <IonLabel>Perfil</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};
